// API-related constants for headers, tokens, and configuration

export const REQUEST_HEADER_AUTH_KEY = 'Authorization'
export const TOKEN_TYPE = 'Bearer'
export const API_TIMEOUT = 60000 // 60 seconds
export const TOKEN_STORAGE_KEY = 'sms_access_token'
export const REFRESH_TOKEN_STORAGE_KEY = 'sms_refresh_token'
